import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useB2cScheduleDetail = (id: number, group_id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [scheduleInfo, setScheduleInfo] = useState<ProjectScheduleInfoDto>();
  const [lastInsertSrl, setLastInsertSrl] = useState<any>(0);
  /* ======================================================
   * hooks
   * ====================================================== */
  const { refetch, isLoading } = useQuery(
    [endpoints.b2c.schedule.info, id],
    () =>
      fetcher.b2c.postProjectScheduleInfo({id: id, group_id: group_id}),
    {
      enabled: (id > 0 || group_id > 0),
      onSuccess: (res: ProjectScheduleInfoResDto) => {
        switch (res.code) {
          case 200:
            setScheduleInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: b2cScheduleInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.b2c.schedule.add],
    fetcher.b2c.postProjectScheduleInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            if (!!res.result) setLastInsertSrl(res.result.id)            
            message.info(MSG.SUCCESS_INSERT, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: b2cScheduleUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.b2c.schedule.update],
    fetcher.b2c.postProjectScheduleUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: b2cScheduleDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.b2c.schedule.delete],
    fetcher.b2c.postProjectScheduleDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { refetch, lastInsertSrl, scheduleInfo, insertSuccess, updateSuccess, deleteSuccess, b2cScheduleInsert, b2cScheduleUpdate, b2cScheduleDelete };
};

export default useB2cScheduleDetail;
